/**
 * H5的互动层消息通信器(和播放层通信, 播放层使用ParentBridge接收)
 */
import ChildBridge from '../ChildBridge';
import { ChannelMessage } from '../ChannelMessage';

export default class IframeChildBridge extends ChildBridge {
  protected onPostMessage(param: ChannelMessage) {
    window.parent.postMessage(param, '*');
  };
  protected onRemoveListener(cb: (...args: any[]) => void) {
    window.removeEventListener('message', cb);
  };
  protected onAddListener(cb: (...args: any[]) => void) {
    window.addEventListener('message', cb);
  };
}
